/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import * as _ from 'lodash';

import {ApiConfig} from '../api/api';
import {AdnHttpService} from './adn-http.service';
import {AdnHttpSender, createAdnHttpResourceSender} from './create-adn-http-resource';
import {AuthHttpInterceptorService} from '../auth/auth-http-interceptor.service';
import {ApiErrorHandlerService} from '../../app/common/directives/error/api-error-handler.service';



@Injectable()
export class ContentSummaryHelper {
  private readonly send: AdnHttpSender;

  constructor(
    AdnHttp: AdnHttpService,
    authHttpInterceptor: AuthHttpInterceptorService,
    ApiErrorHandler: ApiErrorHandlerService
  ) {
    this.send = createAdnHttpResourceSender(AdnHttp, authHttpInterceptor, ApiErrorHandler);
  }

  getProfile(id: string, url: string): Promise<any> {
    return this.send({
      method: 'GET',
      url: ApiConfig.obtain().getVersionedUri(['contentsummary']),
      params: _.assign({}, {format: 'json', concise: true, site: id, url: url}),
      hasErrorHandler: true
    }).catch((err: any) => err.data);
  }

  getAdCount(id: string): Promise<any> {
    return this.send({
      method: 'GET',
      url: ApiConfig.obtain().getVersionedUri(['contentsummary', 'adcount']),
      params: _.assign({}, {site: id}),
      hasErrorHandler: true
    }).catch((err: any) => err.data);
  }

  getAdCounts(id: string): Promise<any> {
    return this.send({
      method: 'GET',
      url: ApiConfig.obtain().getVersionedUri(['contentsummary', 'adcounts']),
      params: _.assign({}, {site: id}),
      hasErrorHandler: true
    }).catch((err: any) => err.data);
  }
}
